import styled from 'styled-components';

export const ModalStyle = styled.div`
  position: relative;
  width: 100%;
  max-width: 60rem;
  height: fit-content;
  display: flex;
  flex-direction: column;
  outline: none;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(100%);
  transition: transform ${props => props.$animationDuration || 300}ms cubic-bezier(0.4, 0, 0.2, 1);

  &[class*='--after-open'] {
    transform: translateY(0);
  }

  &[class*='--before-close'] {
    transform: translateY(100%);
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500;
  background-color: rgba(7, 8, 8, 0.8);

  ${props =>
    props.$customStyles && typeof props.$customStyles === 'object'
      ? Object.entries(props.$customStyles)
          .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`)
          .join('\n')
      : ''}
`;
